import React, { Component } from "react";
import { CrfContext } from "../../CrfContext";
import SideNav from "../sidenav/Sidenav.js";
import DashBoardModal from "./DashBoardModal";
import CheckPreparationModal from "./CheckPreparationModal";
import CheckPreparedModal from "./CheckPreparedModal";
import CheckAvailableModal from "./CheckAvailableModal";
import Pagination from "./Pagination.js";
import AllRequestPagination from "./AllRequestPagination.js";
import moment from "moment";

import { Link } from "react-router-dom";

import "./MyDashboard.css";

import axios from "axios";

import FileDownload from "js-file-download";

import ReactDataSheet from "react-datasheet";
import TransitionsModal from "../modal/modal";

import "react-datasheet/lib/react-datasheet.css";
import {
  DownloadPhase1,
  DownloadCheckPreparation,
  DownloadCheckPrepared,
  DownloadCheckAvailable,
  DownloadReleased,
} from "../downloadAsCSV/downloadAsCsv";
import parse from "date-fns/parse";

export class MyDashboard extends Component {
  state = {
    modalState: false,
    approvedRequest: false,
    allRequests: [],
    approvedRequests: false,

    toggleAllRequests: true,
    toggleForTransmittal: false,
    toggleForReview: false,
    toggleForEndorsement: false,
    toggleReturned: false,
    toggleRejected: false,
    toggleOnHold: false,

    toggleInProcess: false,
    toggleCheckPreparation: false,
    toggleCheckPrepared: false,
    toggleCheckAvailable: false,
    toggleReleased: false,

    phase1: true,
    phase2: false,

    crfPhase2: [],

    crfIds: [],
    csvToDl: [],
    allCrfId: [],
    updateCrf: [],
    updatedElements: "",

    grid: [],

    selectAll: false,
    crfWithValueIds: [],
    crfCount: 0,
    grandTotal: "0.00",
  };

  componentDidMount() {
    axios({
      method: "GET",
      url: `${process.env.REACT_APP_API_KEY}/api/checkRequestForm`,
      headers: {
        "Api-Key":
          "2fd656df11329944f7e5f3be21a48f401fdcd8ec7ff39526d725cc92edebc130",
        Authorization: `Bearer ${localStorage.token}`,
      },
    })
      .then((response) => {
        const newRequest = response.data.data;

        const allCrfId = [];
        for (let i = 0; i < newRequest.length; i++) {
          allCrfId.push(newRequest[i]._id);
        }
        const allRequests = [...newRequest];
        this.setState({
          allRequests: allRequests.reverse(),
          allCrfId: allCrfId,
          crfPhase2: newRequest.filter(
            (crf) =>
              crf.status === "In Process" ||
              crf.status === "Check Preparation" ||
              crf.status === "Check Prepared" ||
              crf.status === "Check Available"
          ),
        });
      })
      .catch((error) => {
          
      });
  }

  handleAllRequest = (e) => {
    e.preventDefault();
    this.setState({
      toggleAllRequests: true,
      toggleForTransmittal: false,
      toggleForReview: false,
      toggleForEndorsement: false,
      toggleReturned: false,
      toggleRejected: false,

      toggleInProcess: false,
      toggleCheckPreparation: false,
      toggleCheckPrepared: false,
      toggleCheckAvailable: false,
      toggleReleased: false,
    });

    document.getElementById("allSelected").style.borderBottom = "3px solid red";
    document.getElementById("allSelected").style.color = "black";

    if (this.state.phase1 === true) {
      document.getElementById("approvedSelected").style.borderBottom =
        "3px solid black";
      document.getElementById("approvedSelected").style.color = "gray";

      document.getElementById("transmittedSelected").style.borderBottom =
        "3px solid black";
      document.getElementById("transmittedSelected").style.color = "gray";

      document.getElementById("reviewedSelected").style.borderBottom =
        "3px solid black";
      document.getElementById("reviewedSelected").style.color = "gray";

      document.getElementById("forEndorsementSelected").style.borderBottom =
        "3px solid black";
      document.getElementById("forEndorsementSelected").style.color = "gray";

      document.getElementById("rejectedSelected").style.borderBottom =
        "3px solid black";
      document.getElementById("rejectedSelected").style.color = "gray";
    } else {
      document.getElementById("inProcessSelected").style.borderBottom =
        "3px solid black";
      document.getElementById("inProcessSelected").style.color = "gray";

      document.getElementById("checkPreparationSelected").style.borderBottom =
        "3px solid black";
      document.getElementById("checkPreparationSelected").style.color = "gray";

      document.getElementById("checkPreparedSelected").style.borderBottom =
        "3px solid black";
      document.getElementById("checkPreparedSelected").style.color = "gray";

      document.getElementById("checkAvailableSelected").style.borderBottom =
        "3px solid black";
      document.getElementById("checkAvailableSelected").style.color = "gray";

      document.getElementById("releasedSelected").style.borderBottom =
        "3px solid black";
      document.getElementById("releasedSelected").style.color = "gray";
    }
  };

  handleApprovedRequest = (e) => {
    e.preventDefault();
    let totalNetPrice = 0;
    for (const obj of this.state.allRequests.filter(
      (crf) => crf.status === "For Transmittal"
    )) {
      totalNetPrice = parseFloat(obj.totalNetPrice) + parseFloat(totalNetPrice);
    }
    this.setState({
      toggleAllRequests: false,
      toggleForTransmittal: true,
      toggleForReview: false,
      toggleForEndorsement: false,
      toggleReturned: false,
      toggleRejected: false,
      toggleOnHold: false,
      grandTotal: totalNetPrice.toFixed(2),
    });

    document.getElementById("onHoldSelected").style.borderBottom =
      "3px solid black";
    document.getElementById("reviewedSelected").style.color = "gray";

    document.getElementById("approvedSelected").style.borderBottom =
      "3px solid red";
    document.getElementById("approvedSelected").style.color = "black";

    document.getElementById("allSelected").style.borderBottom =
      "3px solid black";
    document.getElementById("allSelected").style.color = "gray";

    document.getElementById("transmittedSelected").style.borderBottom =
      "3px solid black";
    document.getElementById("transmittedSelected").style.color = "gray";

    document.getElementById("reviewedSelected").style.borderBottom =
      "3px solid black";
    document.getElementById("reviewedSelected").style.color = "gray";

    document.getElementById("forEndorsementSelected").style.borderBottom =
      "3px solid black";
    document.getElementById("forEndorsementSelected").style.color = "gray";

    document.getElementById("rejectedSelected").style.borderBottom =
      "3px solid black";
    document.getElementById("rejectedSelected").style.color = "gray";
  };

  handleTransmittedRequest = (e) => {
    e.preventDefault();
    let totalNetPrice = 0;
    for (const obj of this.state.allRequests.filter(
      (crf) => crf.status === "For Review"
    )) {
      totalNetPrice = parseFloat(obj.totalNetPrice) + parseFloat(totalNetPrice);
    }
    this.setState({
      toggleAllRequests: false,
      toggleForTransmittal: false,
      toggleForReview: true,
      toggleForEndorsement: false,
      toggleReturned: false,
      toggleRejected: false,
      toggleOnHold: false,
      grandTotal: totalNetPrice.toFixed(2),
    });
    document.getElementById("transmittedSelected").style.borderBottom =
      "3px solid red";
    document.getElementById("transmittedSelected").style.color = "black";

    document.getElementById("onHoldSelected").style.borderBottom =
      "3px solid black";
    document.getElementById("reviewedSelected").style.color = "gray";

    document.getElementById("approvedSelected").style.borderBottom =
      "3px solid black";
    document.getElementById("approvedSelected").style.color = "gray";

    document.getElementById("allSelected").style.borderBottom =
      "3px solid black";
    document.getElementById("allSelected").style.color = "gray";

    document.getElementById("reviewedSelected").style.borderBottom =
      "3px solid black";
    document.getElementById("reviewedSelected").style.color = "gray";

    document.getElementById("forEndorsementSelected").style.borderBottom =
      "3px solid black";
    document.getElementById("forEndorsementSelected").style.color = "gray";

    document.getElementById("rejectedSelected").style.borderBottom =
      "3px solid black";
    document.getElementById("rejectedSelected").style.color = "gray";
  };

  handleReviewedRequest = (e) => {
    e.preventDefault();
    let totalNetPrice = 0;
    for (const obj of this.state.allRequests.filter(
      (crf) => crf.status === "For Endorsement"
    )) {
      totalNetPrice = parseFloat(obj.totalNetPrice) + parseFloat(totalNetPrice);
    }
    this.setState({
      toggleAllRequests: false,
      toggleForTransmittal: false,
      toggleForReview: false,
      toggleForEndorsement: true,
      toggleReturned: false,
      toggleRejected: false,
      toggleOnHold: false,
      grandTotal: totalNetPrice.toFixed(2),
    });
    document.getElementById("reviewedSelected").style.borderBottom =
      "3px solid red";
    document.getElementById("reviewedSelected").style.color = "black";

    document.getElementById("onHoldSelected").style.borderBottom =
      "3px solid black";
    document.getElementById("reviewedSelected").style.color = "gray";

    document.getElementById("transmittedSelected").style.borderBottom =
      "3px solid black";
    document.getElementById("transmittedSelected").style.color = "gray";

    document.getElementById("approvedSelected").style.borderBottom =
      "3px solid black";
    document.getElementById("approvedSelected").style.color = "gray";

    document.getElementById("allSelected").style.borderBottom =
      "3px solid black";
    document.getElementById("allSelected").style.color = "gray";

    document.getElementById("forEndorsementSelected").style.borderBottom =
      "3px solid black";
    document.getElementById("forEndorsementSelected").style.color = "gray";

    document.getElementById("rejectedSelected").style.borderBottom =
      "3px solid black";
    document.getElementById("rejectedSelected").style.color = "gray";
  };

  handleOnHoldRequest = (e) => {
    e.preventDefault();
    let totalNetPrice = 0;
    for (const obj of this.state.allRequests.filter(
      (crf) => crf.status === "On Hold"
    )) {
      totalNetPrice = parseFloat(obj.totalNetPrice) + parseFloat(totalNetPrice);
    }
    this.setState({
      toggleAllRequests: false,
      toggleForTransmittal: false,
      toggleForReview: false,
      toggleForEndorsement: false,
      toggleReturned: false,
      toggleRejected: false,
      toggleOnHold: true,
      grandTotal: totalNetPrice.toFixed(2),
    });

    document.getElementById("onHoldSelected").style.borderBottom =
      "3px solid red";
    document.getElementById("reviewedSelected").style.color = "black";

    document.getElementById("reviewedSelected").style.borderBottom =
      "3px solid black";
    document.getElementById("reviewedSelected").style.color = "gray";

    document.getElementById("transmittedSelected").style.borderBottom =
      "3px solid black";
    document.getElementById("transmittedSelected").style.color = "gray";

    document.getElementById("approvedSelected").style.borderBottom =
      "3px solid black";
    document.getElementById("approvedSelected").style.color = "gray";

    document.getElementById("allSelected").style.borderBottom =
      "3px solid black";
    document.getElementById("allSelected").style.color = "gray";

    document.getElementById("forEndorsementSelected").style.borderBottom =
      "3px solid black";
    document.getElementById("forEndorsementSelected").style.color = "gray";

    document.getElementById("rejectedSelected").style.borderBottom =
      "3px solid black";
    document.getElementById("rejectedSelected").style.color = "gray";
  };

  handleForReturnedRequest = (e) => {
    e.preventDefault();
    let totalNetPrice = 0;
    for (const obj of this.state.allRequests.filter(
      (crf) => crf.status === "Returned"
    )) {
      totalNetPrice = parseFloat(obj.totalNetPrice) + parseFloat(totalNetPrice);
    }
    this.setState({
      toggleAllRequests: false,
      toggleForTransmittal: false,
      toggleForReview: false,
      toggleForEndorsement: false,
      toggleEndorsed: false,
      toggleReturned: true,
      toggleRejected: false,
      toggleOnHold: false,
      grandTotal: totalNetPrice.toFixed(2),
    });

    document.getElementById("forEndorsementSelected").style.borderBottom =
      "3px solid red";
    document.getElementById("forEndorsementSelected").style.color = "black";

    document.getElementById("onHoldSelected").style.borderBottom =
      "3px solid black";
    document.getElementById("reviewedSelected").style.color = "gray";

    document.getElementById("allSelected").style.borderBottom =
      "3px solid black";
    document.getElementById("allSelected").style.color = "gray";

    document.getElementById("approvedSelected").style.borderBottom =
      "3px solid black";
    document.getElementById("approvedSelected").style.color = "gray";

    document.getElementById("transmittedSelected").style.borderBottom =
      "3px solid black";
    document.getElementById("transmittedSelected").style.color = "gray";

    document.getElementById("reviewedSelected").style.borderBottom =
      "3px solid black";
    document.getElementById("reviewedSelected").style.color = "gray";

    document.getElementById("rejectedSelected").style.borderBottom =
      "3px solid black";
    document.getElementById("rejectedSelected").style.color = "gray";
  };

  handleForRejectedRequest = (e) => {
    e.preventDefault();
    let totalNetPrice = 0;
    for (const obj of this.state.allRequests.filter(
      (crf) => crf.status === "Rejected"
    )) {
      totalNetPrice = parseFloat(obj.totalNetPrice) + parseFloat(totalNetPrice);
    }
    this.setState({
      toggleAllRequests: false,
      toggleForTransmittal: false,
      toggleForReview: false,
      toggleForEndorsement: false,
      toggleEndorsed: false,
      toggleReturned: false,
      toggleRejected: true,
      toggleOnHold: false,
      grandTotal: totalNetPrice.toFixed(2),
    });

    document.getElementById("rejectedSelected").style.borderBottom =
      "3px solid red";
    document.getElementById("rejectedSelected").style.color = "black";

    document.getElementById("onHoldSelected").style.borderBottom =
      "3px solid black";
    document.getElementById("reviewedSelected").style.color = "gray";

    document.getElementById("forEndorsementSelected").style.borderBottom =
      "3px solid black";
    document.getElementById("forEndorsementSelected").style.color = "gray";

    document.getElementById("allSelected").style.borderBottom =
      "3px solid black";
    document.getElementById("allSelected").style.color = "gray";

    document.getElementById("approvedSelected").style.borderBottom =
      "3px solid black";
    document.getElementById("approvedSelected").style.color = "gray";

    document.getElementById("transmittedSelected").style.borderBottom =
      "3px solid black";
    document.getElementById("transmittedSelected").style.color = "gray";

    document.getElementById("reviewedSelected").style.borderBottom =
      "3px solid black";
    document.getElementById("reviewedSelected").style.color = "gray";
  };

  handleInProcessRequest = (e) => {
    e.preventDefault();
    const newGrid = [
      [
        { value: "", readOnly: true },
        {
          value: (
            <div className="selectCrfCheckBoxContainer">
              <span className="selectCrfCheckBoxContents">
                <span
                  id="selectAllCrf"
                  className=""
                  onClickCapture={this.toggleCrfSelectAll}
                >
                  <i class="fas fa-check-square" title="Select all"></i>
                </span>
                <span
                  id="unselectAllCrf"
                  className=""
                  onClickCapture={this.toggleCrfUnSelectAll}
                >
                  <i class="fas fa-check-square" title="Unselect all"></i>
                </span>
              </span>
            </div>
          ),
          readOnly: true,
        },
        { value: "", readOnly: true },
        { value: "CRF #", readOnly: true },
        { value: "", readOnly: true },
        { value: "Request Type", readOnly: true },
        { value: "Requesting Amount", readOnly: true },

        { value: "APV#", readOnly: true },
        { value: "Posting Date", readOnly: true },
        { value: "Due Date", readOnly: true },
        { value: "Date Created", readOnly: true },
        { value: "Vendor", readOnly: true },
        { value: "Releasing Center", readOnly: true },
        { value: "Department", readOnly: true },
        { value: "Requestor", readOnly: true },
      ],
    ];
    const filteredCrf = this.state.crfPhase2.filter(
      (crf) => crf.status === "In Process"
    );

    for (let i = 0; i < filteredCrf.length; i++) {
      newGrid.push([
        {
          value: (
            <div className="csvIsDownloaded">
              <span
                style={filteredCrf[i].dateDownloaded ? colorGray : colorRed}
                title={
                  filteredCrf[i].dateDownloaded
                    ? `${filteredCrf[i].dateDownloaded}`
                    : "CSV Not Downloaded"
                }
              >
                <i class="fas fa-file-csv"></i>
              </span>
            </div>
          ),
          csv: filteredCrf[i].dateDownloaded
            ? filteredCrf[i].dateDownloaded
            : "",
          readOnly: true,
        },
        {
          value: (
            <div className="selectCrfCheckBoxContainer">
              <span className="selectCrfCheckBoxContents">
                <span
                  className="selectCrfCheckBox"
                  onClickCapture={this.toggleCrfSelect}
                >
                  <i class="fas fa-check-square" id={filteredCrf[i]._id}></i>
                </span>
              </span>
            </div>
          ),
          readOnly: true,
        },
        { value: i + 1, readOnly: true },
        { value: filteredCrf[i].crfNo, readOnly: true },
        {
          value: (
            <div className="">
              <span className="crfViewLink">
                <span className="crfViewLink">
                  <Link to={`/CheckRequest/${filteredCrf[i]._id}`}>
                    <i class="fas fa-eye"></i>
                  </Link>
                </span>
              </span>
            </div>
          ),
          readOnly: true,
        },
        { value: `${filteredCrf[i].requestType}`, readOnly: true },
        {
          value: (
            <h5 style={amountRequested}>
              {`\u20B1`}{" "}
              {filteredCrf[i].totalNetPrice
                .toFixed(2)
                .replace(/\d(?=(\d{3})+\.)/g, "$&,")}
            </h5>
          ),
          readOnly: true,
        },

        { value: "", crfId: filteredCrf[i]._id },
        { value: "", isUpdated: false, isValid: true },
        {
          value: this.formatDate(filteredCrf[i].dueDate),
          readOnly: true,
        },
        {
          value: `${this.dateWithComma(
            filteredCrf[i].creationDate.slice(4, 16)
          )}`,
          date: filteredCrf[i].creationDate,
          readOnly: true,
        },
        { value: filteredCrf[i].vendor.bpName, readOnly: true },
        { value: filteredCrf[i]?.releasingCenter, readOnly: true },
        { value: filteredCrf[i].department.centerName, readOnly: true },
        {
          value: `${
            filteredCrf[i].requestor.firstName +
            " " +
            filteredCrf[i].requestor.lastName
          }`,
          readOnly: true,
        },
      ]);
    }

    let totalNetPrice = 0;
    for (const obj of filteredCrf) {
      totalNetPrice = parseFloat(obj.totalNetPrice) + parseFloat(totalNetPrice);
    }
    this.setState({
      toggleAllRequests: false,
      toggleInProcess: true,
      toggleCheckPreparation: false,
      toggleCheckPrepared: false,
      toggleCheckAvailable: false,
      toggleReleased: false,
      grid: newGrid,
      grandTotal: totalNetPrice.toFixed(2),
    });

    document.getElementById("allSelected").style.borderBottom =
      "3px solid black";
    document.getElementById("allSelected").style.color = "gray";

    document.getElementById("inProcessSelected").style.borderBottom =
      "3px solid red";
    document.getElementById("inProcessSelected").style.color = "black";

    document.getElementById("checkPreparationSelected").style.borderBottom =
      "3px solid black";
    document.getElementById("checkPreparationSelected").style.color = "gray";

    document.getElementById("checkPreparedSelected").style.borderBottom =
      "3px solid black";
    document.getElementById("checkPreparedSelected").style.color = "gray";

    document.getElementById("checkAvailableSelected").style.borderBottom =
      "3px solid black";
    document.getElementById("checkAvailableSelected").style.color = "gray";

    document.getElementById("releasedSelected").style.borderBottom =
      "3px solid black";
    document.getElementById("releasedSelected").style.color = "gray";
  };

  handleCheckPreparationRequest = (e) => {
    e.preventDefault();

    const newGrid = [
      [
        { value: "", readOnly: true },
        { value: "CRF #", readOnly: true },
        { value: "", readOnly: true },
        { value: "Request Type", readOnly: true },
        { value: "Check Amount", readOnly: true },

        { value: "CV #", readOnly: true, width: 100 },
        { value: "CV Date", readOnly: true, width: 100 },

        { value: "APV #", readOnly: true },
        { value: "Posting Date", readOnly: true },
        { value: "Due Date", readOnly: true },
        { value: "Date Created", readOnly: true },

        { value: "Vendor", readOnly: true },
        { value: "Releasing Center", readOnly: true },
        { value: "Department", readOnly: true },
        { value: "Requestor", readOnly: true },
      ],
    ];
    const checkPreparationCrf = this.state.crfPhase2.filter(
      (crf) => crf.status === "Check Preparation"
    );

    for (let i = 0; i < checkPreparationCrf.length; i++) {
      newGrid.push([
        { value: i + 1, readOnly: true },
        { value: checkPreparationCrf[i].crfNo, readOnly: true },
        {
          value: (
            <div className="">
              <span className="crfViewLink">
                <span className="crfViewLink">
                  <Link to={`/CheckRequest/${checkPreparationCrf[i]._id}`}>
                    <i class="fas fa-eye"></i>
                  </Link>
                </span>
              </span>
            </div>
          ),
          readOnly: true,
        },
        { value: `${checkPreparationCrf[i].requestType}`, readOnly: true },
        {
          readOnly: true,
          value: (
            <h5 style={amountRequested}>
              {`\u20B1`}{" "}
              {checkPreparationCrf[i].totalNetPrice
                .toFixed(2)
                .replace(/\d(?=(\d{3})+\.)/g, "$&,")}
            </h5>
          ),
          price: checkPreparationCrf[i].totalNetPrice.toFixed(2),
        },

        {
          value: "",
          crfId: checkPreparationCrf[i]._id,
          amount: checkPreparationCrf[i].totalNetPrice,
        },
        { value: "", isValid: false },
        { value: checkPreparationCrf[i].apvNo, readOnly: true },
        {
          value: this.formatDate(checkPreparationCrf[i].postingDate),
          readOnly: true,
        },
        {
          value: this.formatDate(checkPreparationCrf[i].dueDate),
          readOnly: true,
        },
        {
          value: `${this.dateWithComma(
            checkPreparationCrf[i].creationDate.slice(4, 16)
          )}`,
          date: checkPreparationCrf[i].creationDate,
          readOnly: true,
        },

        { value: checkPreparationCrf[i].vendor.bpName, readOnly: true },
        { value: checkPreparationCrf[i]?.releasingCenter, readOnly: true },
        { value: checkPreparationCrf[i].department.centerName, readOnly: true },
        {
          value: `${
            checkPreparationCrf[i].requestor.firstName +
            " " +
            checkPreparationCrf[i].requestor.lastName
          }`,
          readOnly: true,
        },
      ]);
    }

    let totalNetPrice = 0;
    for (const obj of checkPreparationCrf) {
      totalNetPrice = parseFloat(obj.totalNetPrice) + parseFloat(totalNetPrice);
    }
    this.setState({
      toggleAllRequests: false,
      toggleInProcess: false,
      toggleCheckPreparation: true,
      toggleCheckPrepared: false,
      toggleCheckAvailable: false,
      toggleReleased: false,
      grandTotal: totalNetPrice.toFixed(2),
      grid: newGrid,
    });

    document.getElementById("allSelected").style.borderBottom =
      "3px solid black";
    document.getElementById("allSelected").style.color = "gray";

    document.getElementById("inProcessSelected").style.borderBottom =
      "3px solid black";
    document.getElementById("inProcessSelected").style.color = "gray";

    document.getElementById("checkPreparationSelected").style.borderBottom =
      "3px solid red";
    document.getElementById("checkPreparationSelected").style.color = "black";

    document.getElementById("checkPreparedSelected").style.borderBottom =
      "3px solid black";
    document.getElementById("checkPreparedSelected").style.color = "gray";

    document.getElementById("checkAvailableSelected").style.borderBottom =
      "3px solid black";
    document.getElementById("checkAvailableSelected").style.color = "gray";

    document.getElementById("releasedSelected").style.borderBottom =
      "3px solid black";
    document.getElementById("releasedSelected").style.color = "gray";
  };

  handleCheckPreparedRequest = (e) => {
    e.preventDefault();
    const newGrid = [
      [
        { value: "", readOnly: true },
        { value: "CRF #", readOnly: true },
        { value: "", readOnly: true },
        { value: "Request Type", readOnly: true },
        { value: "Check Amount", readOnly: true },

        { value: "Payment Ref", readOnly: true },
        { value: "Check Available Date", readOnly: true },
        { value: "Check Date", readOnly: true },
        { value: "CV #", readOnly: true },
        { value: "CV Date", readOnly: true },
        { value: "Due Date", readOnly: true },
        { value: "Date Created", readOnly: true },
        { value: "Expected Completion Date", readOnly: true },

        { value: "Vendor", readOnly: true },
        { value: "Releasing Center", readOnly: true },
        { value: "Department", readOnly: true },
        { value: "Requestor", readOnly: true },
      ],
    ];
    const filteredCrf = this.state.crfPhase2.filter(
      (crf) => crf.status === "Check Prepared"
    );

    for (let i = 0; i < filteredCrf.length; i++) {
      newGrid.push([
        { value: i + 1, readOnly: true },
        { value: filteredCrf[i].crfNo, readOnly: true },
        {
          value: (
            <div className="">
              <span className="crfViewLink">
                <span className="crfViewLink">
                  <Link to={`/CheckRequest/${filteredCrf[i]._id}`}>
                    <i class="fas fa-eye"></i>
                  </Link>
                </span>
              </span>
            </div>
          ),
          readOnly: true,
        },
        { value: `${filteredCrf[i].requestType}`, readOnly: true },
        {
          value: (
            <h5 style={amountRequested}>
              {`\u20B1`}{" "}
              {filteredCrf[i].totalNetPrice
                .toFixed(2)
                .replace(/\d(?=(\d{3})+\.)/g, "$&,")}
            </h5>
          ),
          readOnly: true,
        },

        { value: "", crfId: filteredCrf[i]._id },
        { value: "", isValid: false },
        {
          value: "",
          isValid: false,
        },
        {
          value: filteredCrf[i].cvNo,
          readOnly: true,
        },
        {
          value:
            filteredCrf[i]?.cvDate &&
            moment(filteredCrf[i].cvDate).format("MMM DD, YYYY"),
          readOnly: true,
        },
        {
          value: moment(filteredCrf[i].dueDate).format("MMM DD, YYYY"),
          readOnly: true,
        },
        {
          value: `${moment(filteredCrf[i].creationDate).format(
            "MMM DD, YYYY"
          )}`,
          date: filteredCrf[i].creationDate,
          readOnly: true,
        },
        {
          value: moment(filteredCrf[i].expectedCompletionDate).format(
            "MMM DD, YYYY"
          ),
          date: filteredCrf[i].expectedCompletionDate,
          readOnly: true,
        },

        { value: filteredCrf[i].vendor.bpName, readOnly: true },
        { value: filteredCrf[i]?.releasingCenter, readOnly: true },
        { value: filteredCrf[i].department.centerName, readOnly: true },
        {
          value: `${
            filteredCrf[i].requestor.firstName +
            " " +
            filteredCrf[i].requestor.lastName
          }`,
          readOnly: true,
        },
      ]);
    }
    let totalNetPrice = 0;
    for (const obj of filteredCrf) {
      totalNetPrice = parseFloat(obj.totalNetPrice) + parseFloat(totalNetPrice);
    }
    this.setState({
      toggleAllRequests: false,
      toggleInProcess: false,
      toggleCheckPreparation: false,
      toggleCheckPrepared: true,
      toggleCheckAvailable: false,
      toggleReleased: false,
      grid: newGrid,
      grandTotal: totalNetPrice.toFixed(2),
    });

    document.getElementById("allSelected").style.borderBottom =
      "3px solid black";
    document.getElementById("allSelected").style.color = "gray";

    document.getElementById("inProcessSelected").style.borderBottom =
      "3px solid black";
    document.getElementById("inProcessSelected").style.color = "gray";

    document.getElementById("checkPreparationSelected").style.borderBottom =
      "3px solid black";
    document.getElementById("checkPreparationSelected").style.color = "gray";

    document.getElementById("checkPreparedSelected").style.borderBottom =
      "3px solid red";
    document.getElementById("checkPreparedSelected").style.color = "black";

    document.getElementById("checkAvailableSelected").style.borderBottom =
      "3px solid black";
    document.getElementById("checkAvailableSelected").style.color = "gray";

    document.getElementById("releasedSelected").style.borderBottom =
      "3px solid black";
    document.getElementById("releasedSelected").style.color = "gray";
  };

  handleCheckAvailableRequest = (e) => {
    e.preventDefault();
    const newGrid = [
      [
        { value: "", readOnly: true },
        { value: "CRF #", readOnly: true },
        { value: "", readOnly: true },
        { value: "Request Type", readOnly: true },
        { value: "Check Amount", readOnly: true },

        { value: "Released Date", readOnly: true },
        { value: "Payment Ref", readOnly: true },
        { value: "Check Date", readOnly: true },
        { value: "Due Date", readOnly: true },
        { value: "Date Created", readOnly: true },
        { value: "Check Available Date", readOnly: true },
        { value: "Vendor", readOnly: true },
        { value: "Releasing Center", readOnly: true },
        { value: "Department", readOnly: true },
        { value: "Requestor", readOnly: true },
      ],
    ];
    const filteredCrf = this.state.crfPhase2.filter(
      (crf) => crf.status === "Check Available"
    );

    for (let i = 0; i < filteredCrf.length; i++) {
      newGrid.push([
        { value: i + 1, readOnly: true },
        { value: filteredCrf[i].crfNo, readOnly: true },
        {
          value: (
            <div className="">
              <span className="crfViewLink">
                <span className="crfViewLink">
                  <Link to={`/CheckRequest/${filteredCrf[i]._id}`}>
                    <i class="fas fa-eye"></i>
                  </Link>
                </span>
              </span>
            </div>
          ),
          readOnly: true,
        },
        { value: `${filteredCrf[i].requestType}`, readOnly: true },
        {
          value: (
            <h5 style={amountRequested}>
              {`\u20B1`}{" "}
              {filteredCrf[i].totalNetPrice
                .toFixed(2)
                .replace(/\d(?=(\d{3})+\.)/g, "$&,")}
            </h5>
          ),
          readOnly: true,
        },

        { value: "", crfId: filteredCrf[i]._id, isValid: false },
        { value: filteredCrf[i].checkNo, readOnly: true },
        {
          value: this.formatDate(filteredCrf[i].checkDate),
          readOnly: true,
        },
        {
          value: `${this.dateWithComma(
            filteredCrf[i].creationDate.slice(4, 16)
          )}`,
          date: filteredCrf[i].creationDate,
          readOnly: true,
        },
        {
          value: this.formatDate(filteredCrf[i].dueDate),
          readOnly: true,
        },
        {
          value: this.formatDate(filteredCrf[i].checkAvailableDate),
          readOnly: true,
        },
        { value: filteredCrf[i].vendor.bpName, readOnly: true },
        { value: filteredCrf[i]?.releasingCenter, readOnly: true },
        { value: filteredCrf[i].department.centerName, readOnly: true },
        {
          value: `${
            filteredCrf[i].requestor.firstName +
            " " +
            filteredCrf[i].requestor.lastName
          }`,
          readOnly: true,
        },
      ]);
    }
    let totalNetPrice = 0;
    for (const obj of filteredCrf) {
      totalNetPrice = parseFloat(obj.totalNetPrice) + parseFloat(totalNetPrice);
    }

    this.setState({
      toggleAllRequests: false,
      toggleInProcess: false,
      toggleCheckPreparation: false,
      toggleCheckPrepared: false,
      toggleCheckAvailable: true,
      toggleReleased: false,
      grid: newGrid,
      grandTotal: totalNetPrice.toFixed(2),
    });

    document.getElementById("allSelected").style.borderBottom =
      "3px solid black";
    document.getElementById("allSelected").style.color = "gray";

    document.getElementById("inProcessSelected").style.borderBottom =
      "3px solid black";
    document.getElementById("inProcessSelected").style.color = "gray";

    document.getElementById("checkPreparationSelected").style.borderBottom =
      "3px solid black";
    document.getElementById("checkPreparationSelected").style.color = "gray";

    document.getElementById("checkPreparedSelected").style.borderBottom =
      "3px solid black";
    document.getElementById("checkPreparedSelected").style.color = "gray";

    document.getElementById("checkAvailableSelected").style.borderBottom =
      "3px solid red";
    document.getElementById("checkAvailableSelected").style.color = "black";

    document.getElementById("releasedSelected").style.borderBottom =
      "3px solid black";
    document.getElementById("releasedSelected").style.color = "gray";
  };

  handleReleasedRequest = (e) => {
    e.preventDefault();
    this.setState({
      toggleAllRequests: false,
      toggleInProcess: false,
      toggleCheckPreparation: false,
      toggleCheckPrepared: false,
      toggleCheckAvailable: false,
      toggleReleased: true,
    });

    document.getElementById("allSelected").style.borderBottom =
      "3px solid black";
    document.getElementById("allSelected").style.color = "gray";

    document.getElementById("inProcessSelected").style.borderBottom =
      "3px solid black";
    document.getElementById("inProcessSelected").style.color = "gray";

    document.getElementById("checkPreparationSelected").style.borderBottom =
      "3px solid black";
    document.getElementById("checkPreparationSelected").style.color = "gray";

    document.getElementById("checkPreparedSelected").style.borderBottom =
      "3px solid black";
    document.getElementById("checkPreparedSelected").style.color = "gray";

    document.getElementById("checkAvailableSelected").style.borderBottom =
      "3px solid black";
    document.getElementById("checkAvailableSelected").style.color = "gray";

    document.getElementById("releasedSelected").style.borderBottom =
      "3px solid red";
    document.getElementById("releasedSelected").style.color = "black";
  };

  handlePhase1 = () => {
    this.setState({
      phase1: true,
      phase2: false,

      toggleAllRequests: true,
      toggleInProcess: false,
      toggleCheckPreparation: false,
      toggleCheckPrepared: false,
      toggleCheckAvailable: false,
      toggleReleased: false,
      grid: [],
    });

    document.getElementById("ph1Btn").style.background = "#ee3124";
    document.getElementById("ph1Btn").style.color = "white";
    document.getElementById("ph2Btn").style.background = "gray";

    document.getElementById("allSelected").style.borderBottom = "3px solid red";
    document.getElementById("allSelected").style.color = "black";

    if (this.state.phase1 === true) {
      document.getElementById("approvedSelected").style.borderBottom =
        "3px solid black";
      document.getElementById("approvedSelected").style.color = "gray";

      document.getElementById("transmittedSelected").style.borderBottom =
        "3px solid black";
      document.getElementById("transmittedSelected").style.color = "gray";

      document.getElementById("reviewedSelected").style.borderBottom =
        "3px solid black";
      document.getElementById("reviewedSelected").style.color = "gray";

      document.getElementById("forEndorsementSelected").style.borderBottom =
        "3px solid black";
      document.getElementById("forEndorsementSelected").style.color = "gray";

      document.getElementById("rejectedSelected").style.borderBottom =
        "3px solid black";
      document.getElementById("rejectedSelected").style.color = "gray";
    } else {
      document.getElementById("inProcessSelected").style.borderBottom =
        "3px solid black";
      document.getElementById("inProcessSelected").style.color = "gray";

      document.getElementById("checkPreparationSelected").style.borderBottom =
        "3px solid black";
      document.getElementById("checkPreparationSelected").style.color = "gray";

      document.getElementById("checkPreparedSelected").style.borderBottom =
        "3px solid black";
      document.getElementById("checkPreparedSelected").style.color = "gray";

      document.getElementById("checkAvailableSelected").style.borderBottom =
        "3px solid black";
      document.getElementById("checkAvailableSelected").style.color = "gray";

      document.getElementById("releasedSelected").style.borderBottom =
        "3px solid black";
      document.getElementById("releasedSelected").style.color = "gray";
    }
  };

  handlePhase2 = () => {
    this.setState({
      phase2: true,
      phase1: false,

      toggleAllRequests: false,
      toggleForTransmittal: false,
      toggleForReview: false,
      toggleForEndorsement: false,
      toggleReturned: false,
      toggleRejected: false,
      toggleOnHold: false,
    });

    document.getElementById("ph2Btn").style.background = "#ee3124";
    document.getElementById("ph2Btn").style.color = "white";
    document.getElementById("ph1Btn").style.background = "gray";

    document.getElementById("allSelected").style.borderBottom = "3px solid red";
    document.getElementById("allSelected").style.color = "black";

    if (this.state.phase1 === true) {
      document.getElementById("approvedSelected").style.borderBottom =
        "3px solid black";
      document.getElementById("approvedSelected").style.color = "gray";

      document.getElementById("transmittedSelected").style.borderBottom =
        "3px solid black";
      document.getElementById("transmittedSelected").style.color = "gray";

      document.getElementById("reviewedSelected").style.borderBottom =
        "3px solid black";
      document.getElementById("reviewedSelected").style.color = "gray";

      document.getElementById("forEndorsementSelected").style.borderBottom =
        "3px solid black";
      document.getElementById("forEndorsementSelected").style.color = "gray";

      document.getElementById("rejectedSelected").style.borderBottom =
        "3px solid black";
      document.getElementById("rejectedSelected").style.color = "gray";
    } else {
      document.getElementById("inProcessSelected").style.borderBottom =
        "3px solid black";
      document.getElementById("inProcessSelected").style.color = "gray";

      document.getElementById("checkPreparationSelected").style.borderBottom =
        "3px solid black";
      document.getElementById("checkPreparationSelected").style.color = "gray";

      document.getElementById("checkPreparedSelected").style.borderBottom =
        "3px solid black";
      document.getElementById("checkPreparedSelected").style.color = "gray";

      document.getElementById("checkAvailableSelected").style.borderBottom =
        "3px solid black";
      document.getElementById("checkAvailableSelected").style.color = "gray";

      document.getElementById("releasedSelected").style.borderBottom =
        "3px solid black";
      document.getElementById("releasedSelected").style.color = "gray";
    }
  };

  toggleCrfSelect = (e) => {
    e.target.style.color = "red";

    if (!this.state.csvToDl.includes(e.target.id)) {
      this.state.csvToDl.push(e.target.id);
    } else {
      if (this.state.csvToDl.indexOf(e.target.id) === 0) {
        this.state.csvToDl.shift();
        e.target.style.color = "rgb(228, 225, 225)";
      } else {
        e.target.style.color = "rgb(228, 225, 225)";
        this.state.csvToDl.splice(this.state.csvToDl.indexOf(e.target.id), 1);
      }
    }
  };

  toggleCrfSelectAll = () => {
    document.getElementById("selectAllCrf").style.display = "none";
    document.getElementById("unselectAllCrf").style.display = "block";
    const checkIcon = document.getElementsByClassName("selectCrfCheckBox");
    for (let i = 0; i < checkIcon.length; i++) {
      document.getElementsByClassName("selectCrfCheckBox")[
        i
      ].children[0].style.color = "red";
    }

    const allInProcess = [];
    for (const obj of this.state.allRequests) {
      if (obj.status === "In Process") allInProcess.push(obj._id);
    }

    this.setState({
      selectAll: false,
      csvToDl: allInProcess,
    });
  };

  componentDidUpdate() {}

  toggleCrfUnSelectAll = () => {
    document.getElementById("unselectAllCrf").style.display = "none";
    document.getElementById("selectAllCrf").style.display = "block";

    const checkIcon = document.getElementsByClassName("selectCrfCheckBox");
    this.setState({
      selectAll: false,
      csvToDl: [],
    });
    for (let i = 0; i < checkIcon.length; i++) {
      document.getElementsByClassName("selectCrfCheckBox")[
        i
      ].children[0].style.color = "rgb(228, 225, 225)";
    }
  };

  handleMultipleCsvDl = (e) => {
    e.preventDefault();

    axios({
      method: "POST",
      url: `${process.env.REACT_APP_API_KEY}/api/downloadcsv/multiple`,
      data: {
        crfIds: this.state.csvToDl,
      },
      headers: {
        "Api-Key":
          "2fd656df11329944f7e5f3be21a48f401fdcd8ec7ff39526d725cc92edebc130",
        Authorization: `Bearer ${localStorage.token}`,
      },
    })
      .then((response) => {
        FileDownload(response.data, "report.csv");
        window.location.reload();
      })
      .catch((error) => {
        alert("Please make sure to check the row you wanted to download");
          
      });
  };

  handleUpdateToCheckPreparation = (e) => {
    e.preventDefault();

    const crfWithApv = this.state.grid.filter(
      (crf) => crf[8].value !== "" && crf[8].value !== "Posting Date"
    );
    const count = crfWithApv.length;

    for (let i = 0; i < crfWithApv.length; i++) {
      var stringDate = crfWithApv[i][8].value;
      if (stringDate.match("^\\d{2}/\\d{2}/\\d{4}$")) {
        var date = new Date(stringDate);

        if (isNaN(date)) {
        } else {
          axios({
            method: "PUT",
            url: `${process.env.REACT_APP_API_KEY}/api/checkAvailable/inProcess/${crfWithApv[i][7].crfId}`,
            data: {
              apvNo: crfWithApv[i][7].value,
              postingDate: crfWithApv[i][8].value,
            },
            headers: {
              "Api-Key":
                "2fd656df11329944f7e5f3be21a48f401fdcd8ec7ff39526d725cc92edebc130",
              Authorization: `Bearer ${localStorage.token}`,
            },
          })
            .then((response) => {
              this.setState({
                crfCount: this.state.crfCount + 1,
              });

              if (this.state.crfCount === count) {
                window.location.reload();
              }
            })
            .catch((error) => {
                
            });
        }
      } else {
      }
    }
  };

  handleResetAllRequest = () => {
    axios({
      method: "GET",
      url: `${process.env.REACT_APP_API_KEY}/api/checkRequestForm`,
      headers: {
        "Api-Key":
          "2fd656df11329944f7e5f3be21a48f401fdcd8ec7ff39526d725cc92edebc130",
        Authorization: `Bearer ${localStorage.token}`,
      },
    })
      .then((response) => {
        const newRequest = response.data.data;
        const allCrfId = [];
        this.setState({
          allRequests: newRequest.reverse(),
          crfPhase2: newRequest.filter(
            (crf) =>
              crf.status === "In Process" ||
              crf.status === "Check Preparation" ||
              crf.status === "Check Prepared" ||
              crf.status === "Check Available"
          ),
        });
      })
      .catch((error) => {
          
      });
  };

  handleUpdateToCheckPrepared = () => {
    const crfWithApv = this.state.grid.filter(
      (crf) => crf[5].value !== "" && crf[1].value !== "CRF #"
    );

    const count = crfWithApv.length;

    for (let i = 0; i < crfWithApv.length; i++) {
      var stringDate = crfWithApv[i][6].value;
      if (true) {
        var date = new Date(stringDate);

        axios({
          method: "PUT",
          url: `${process.env.REACT_APP_API_KEY}/api/checkAvailable/checkPreparation/${crfWithApv[i][5].crfId}`,
          data: {
            checkAmount: crfWithApv[i][5].amount,
            cvNo: crfWithApv[i][5].value,
            cvDate: crfWithApv[i][6].value,
          },
          headers: {
            "Api-Key":
              "2fd656df11329944f7e5f3be21a48f401fdcd8ec7ff39526d725cc92edebc130",
            Authorization: `Bearer ${localStorage.token}`,
          },
        })
          .then((response) => {
            this.setState({
              crfCount: this.state.crfCount + 1,
            });
            if (this.state.crfCount === count) {
              window.location.reload();
            }
          })
          .catch((error) => {
              
          });
      }
    }
  };

  handleUpdateToCheckAvailable = () => {
    const crfWithApv = this.state.grid.filter(
      (crf) => crf[6].value !== "" && crf[6].value !== "Check Available Date"
    );

    const count = crfWithApv.length;
    for (let i = 0; i < crfWithApv.length; i++) {
      var stringDate = crfWithApv[i][6].value;
      if (stringDate.match("^\\d{2}/\\d{2}/\\d{4}$")) {
        var date = new Date(stringDate);

        if (isNaN(date)) {
        } else {
          axios({
            method: "PUT",
            url: `${process.env.REACT_APP_API_KEY}/api/checkAvailable/checkPrepared/${crfWithApv[i][5].crfId}`,
            data: {
              checkNo: crfWithApv[i][5].value,
              checkAvailableDate: crfWithApv[i][6].value,
              checkDate: crfWithApv[i][7].value,
            },
            headers: {
              "Api-Key":
                "2fd656df11329944f7e5f3be21a48f401fdcd8ec7ff39526d725cc92edebc130",
              Authorization: `Bearer ${localStorage.token}`,
            },
          })
            .then((response) => {
              this.setState({
                crfCount: this.state.crfCount + 1,
              });

              if (this.state.crfCount === count) {
                window.location.reload();
              }
            })
            .catch((error) => {
                
            });
        }
      } else {
      }
    }
  };

  handleUpdateToCheckReleased = () => {
    const crfWithApv = this.state.grid.filter(
      (crf) => crf[5].value !== "" && crf[5].value !== "Released Date"
    );

    const count = crfWithApv.length;

    for (let i = 0; i < crfWithApv.length; i++) {
      var stringDate = crfWithApv[i][5].value;

      if (stringDate.match("^\\d{2}/\\d{2}/\\d{4}$")) {
        var date = new Date(stringDate);
        date.setDate(date.getDate() + 1);
        if (isNaN(date)) {
        } else {
          axios({
            method: "PUT",
            url: `${process.env.REACT_APP_API_KEY}/api/checkAvailable/checkAvailable/${crfWithApv[i][5].crfId}`,
            data: {
              dateReleased: date,
            },
            headers: {
              "Api-Key":
                "2fd656df11329944f7e5f3be21a48f401fdcd8ec7ff39526d725cc92edebc130",
              Authorization: `Bearer ${localStorage.token}`,
            },
          })
            .then((response) => {
              this.setState({
                crfCount: this.state.crfCount + 1,
              });

              if (this.state.crfCount === count) {
                window.location.reload();
              }
            })
            .catch((error) => {
                
            });
        }
      } else {
      }
    }
  };

  handleShowModal = () => {
    document.getElementById("modalBody").style.display = "block";
  };

  closeModal = () => {
    document.getElementById("modalBody").style.display = "none";
  };

  dateWithComma = (date) => {
    const newDate = date.split(" ");
    const month = newDate[0];
    const day = newDate[1];
    const year = newDate[2];
    return `${month} ${day}, ${year}`;
  };
  handleModal = () => {
    this.setState({
      modalState: !this.state.modalState,
    });
  };
  formatDate = (date) => {
    let dateArray = "";
    let month = "";
    let day = "";
    let year = "";

    if (date.length === 10) {
      dateArray = date.split("/");
      month = dateArray[0];
      day = dateArray[1];
      year = dateArray[2];
    } else {
      dateArray = date.split("-");
      month = dateArray[1];
      day = dateArray[2].substring(0, 2);
      year = dateArray[0];
    }
    switch (month) {
      case "02":
        month = "Feb";
        break;
      case "03":
        month = "Mar";
        break;
      case "04":
        month = "Apr";
        break;
      case "05":
        month = "May";
        break;
      case "06":
        month = "Jun";
        break;
      case "07":
        month = "Jul";
        break;
      case "08":
        month = "Aug";
        break;
      case "09":
        month = "Sep";
        break;
      case "10":
        month = "Oct";
        break;
      case "11":
        month = "Nov";
        break;
      case "12":
        month = "Dec";
        break;
      default:
        month = "Jan";
    }
    return `${month} ${day}, ${year}`;
  };

  checkReleasedformatDate = (date) => {
    const dateArray = date.split("/");

    let month = dateArray[0];
    const day = dateArray[1];
    const year = dateArray[2];
    switch (dateArray[1]) {
      case "02":
        month = "Feb";
        break;
      case "03":
        month = "Mar";
        break;
      case "04":
        month = "Apr";
        break;
      case "05":
        month = "May";
        break;
      case "06":
        month = "Jun";
        break;
      case "07":
        month = "Jul";
        break;
      case "08":
        month = "Aug";
        break;
      case "09":
        month = "Sep";
        break;
      case "10":
        month = "Oct";
        break;
      case "11":
        month = "Nov";
        break;
      case "12":
        month = "Dec";
        break;
      default:
        month = "Jan";
    }
    return `${month} ${day}, ${year}`;
  };

  addCommas(nStr) {
    nStr += "";
    var x = nStr.split(".");
    var x1 = x[0];
    var x2 = x.length > 1 ? "." + x[1] : "";
    var rgx = /(\d+)(\d{3})/;
    while (rgx.test(x1)) {
      x1 = x1.replace(rgx, "$1" + "," + "$2");
    }
    return x1 + x2;
  }

  sortList = (allRequests) => {
    const finalArray = [];
    allRequests.sort((a, b) => {
      return b.crfNo - a.crfNo;
    });
    allRequests.filter((element, index) => {
      if (index === 0 || element.number !== allRequests[index - 1].number) {
        finalArray.push(element);
      } else {
        finalArray.push(element);
      }
    });
    return finalArray;
  };

  getOrNumber = (crfNo) => {
    return "N/A";
  };

  render() {
    let crfUpdated = "";

    let allRequests = [];
    if (this.state.toggleAllRequests && this.state.phase1) {
      allRequests = this.state.allRequests.filter(
        (crf) =>
          crf.status === "For Approval" ||
          crf.status === "For Transmittal" ||
          crf.status === "For Review" ||
          crf.status === "For Endorsement" ||
          crf.status === "On Hold" ||
          crf.status === "Returned" ||
          crf.status === "Rejected" ||
          crf.status === "In Process" ||
          crf.status === "Check Preparation" ||
          crf.status === "Check Prepared" ||
          crf.status === "Check Available" ||
          crf.status === "Check Released"
      );
    }

    if (this.state.toggleAllRequests && this.state.phase2) {
      allRequests = this.state.allRequests.filter(
        (crf) =>
          crf.status === "In Process" ||
          crf.status === "Check Preparation" ||
          crf.status === "Check Prepared" ||
          crf.status === "Check Available" ||
          crf.status === "Check Released"
      );
    }

    if (this.state.toggleForTransmittal) {
      allRequests = this.state.allRequests.filter(
        (crf) => crf.status === "For Transmittal"
      );
    }

    if (this.state.toggleForReview) {
      allRequests = this.state.allRequests.filter(
        (crf) => crf.status === "For Review"
      );
    }

    if (this.state.toggleForEndorsement) {
      allRequests = this.state.allRequests.filter(
        (crf) => crf.status === "For Endorsement"
      );
    }

    if (this.state.toggleReturned) {
      allRequests = this.state.allRequests.filter(
        (crf) => crf.status === "Returned"
      );
    }

    if (this.state.toggleRejected) {
      allRequests = this.state.allRequests.filter(
        (crf) => crf.status === "Rejected"
      );
    }

    if (this.state.toggleOnHold) {
      allRequests = this.state.allRequests.filter(
        (crf) => crf.status === "On Hold"
      );
    }

    if (this.state.toggleInProcess) {
      allRequests = this.state.allRequests.filter(
        (crf) => crf.status === "In Process"
      );
      document.getElementById("myDashboardHeader").style.height = "45px";
    }

    if (this.state.toggleCheckPreparation) {
      allRequests = this.state.allRequests.filter(
        (crf) => crf.status === "Check Preparation"
      );
      document.getElementById("myDashboardHeader").style.height = "45px";
    }

    if (this.state.toggleCheckPrepared) {
      allRequests = this.state.allRequests.filter(
        (crf) => crf.status === "Check Prepared"
      );
      document.getElementById("myDashboardHeader").style.height = "45px";
    }

    if (this.state.toggleCheckAvailable) {
      allRequests = this.state.allRequests.filter(
        (crf) => crf.status === "Check Available"
      );
      document.getElementById("myDashboardHeader").style.height = "45px";
    }

    if (this.state.toggleReleased) {
      allRequests = this.state.allRequests.filter(
        (crf) => crf.status === "Check Released"
      );
    }

    return (
      <CrfContext.Consumer>
        {(context) => (
          <div id="mainPage">
            <div id="sidePanel">
              {this.state.toggleInProcess ? (
                <DashBoardModal
                  handleUpdateToCheckPreparation={
                    this.handleUpdateToCheckPreparation
                  }
                  grid={this.state.grid}
                  closeModal={this.closeModal}
                />
              ) : null}

              {this.state.toggleCheckPreparation ? (
                <CheckPreparationModal
                  handleUpdateToCheckPrepared={this.handleUpdateToCheckPrepared}
                  grid={this.state.grid}
                  closeModal={this.closeModal}
                />
              ) : null}

              {this.state.toggleCheckPrepared ? (
                <CheckPreparedModal
                  handleUpdateToCheckAvailable={
                    this.handleUpdateToCheckAvailable
                  }
                  grid={this.state.grid}
                  closeModal={this.closeModal}
                />
              ) : null}

              {this.state.toggleCheckAvailable ? (
                <CheckAvailableModal
                  handleUpdateToCheckReleased={this.handleUpdateToCheckReleased}
                  grid={this.state.grid}
                  closeModal={this.closeModal}
                />
              ) : null}

              <SideNav
                testState={context.state.testState}
                toggleBtn1List={context.toggleBtn1List}
                toggleBtn2List={context.toggleBtn2List}
                btn1List={context.state.btn1List}
                btn2List={context.state.btn2List}
                userRole={context.state.userRole}
              />
            </div>
            <div id="mainPanel">
              <TransitionsModal
                modalState={this.state.modalState}
                handleModal={this.handleModal}
                allRequests={this.state.allRequests}
              />
              <div className="requestSelectionPanel">
                <div className="myRequestHeader" id="myDashboardHeader">
                  <div className="myRequestHeader1Container">
                    <h1>My Dashboard</h1>
                    {this.state.updatedElements}
                    <div className="myRequestTools">
                      <button
                        onClick={this.handlePhase1}
                        id="ph1Btn"
                        className="ph1Btn"
                      >
                        Requests
                      </button>
                      <button
                        onClick={this.handlePhase2}
                        id="ph2Btn"
                        className="ph2Btn"
                      >
                        Checks
                      </button>
                      {/* <button
                        onClick={this.handleModal}
                        id='ph2Btn'
                        className='ph2Btn'
                      >
                        In Queue
                      </button> */}
                      {allRequests.length > 0 && !this.state.toggleInProcess ? (
                        <button
                          onClick={() => {
                            if (this.state.phase1) {
                              DownloadPhase1(allRequests);
                            }
                            if (this.state.toggleCheckPreparation) {
                              DownloadCheckPreparation(allRequests);
                            }
                            if (this.state.toggleCheckPrepared) {
                              DownloadCheckPrepared(allRequests);
                            }
                            if (this.state.toggleCheckAvailable) {
                              DownloadCheckAvailable(allRequests);
                            }
                            if (this.state.toggleReleased) {
                              DownloadReleased(allRequests);
                            }
                          }}
                          id="ph2Btn"
                          className="ph2Btn"
                        >
                          Download as CSV
                        </button>
                      ) : null}
                    </div>
                    {this.state.toggleInProcess ? (
                      <div className="myRequestTools">
                        <button
                          className="dlSelectedBtn"
                          onClick={this.handleMultipleCsvDl}
                        >
                          <i
                            className="fas fa-file-csv"
                            id="dlSelectedBtnIcon"
                          ></i>
                          Download Selected
                        </button>
                      </div>
                    ) : null}
                  </div>
                  <div className="sortingButtons">
                    {this.state.phase1 === true ? (
                      <button onClick={this.handleAllRequest}>
                        <span id="allSelected" className="sortBtnInitital">
                          All Request
                        </span>
                      </button>
                    ) : (
                      <button
                        onClick={this.handleAllRequest}
                        style={displayNone}
                      >
                        <span id="allSelected" className="sortBtnInitital">
                          All Request
                        </span>
                      </button>
                    )}
                    {this.state.phase1 === true ? (
                      <>
                        <button onClick={this.handleApprovedRequest}>
                          <span id="approvedSelected" className="sortBtn">
                            For Transmittal
                          </span>
                        </button>
                        <button onClick={this.handleTransmittedRequest}>
                          <span id="transmittedSelected" className="sortBtn">
                            For Review
                          </span>
                        </button>
                        <button onClick={this.handleReviewedRequest}>
                          <span id="reviewedSelected" className="sortBtn">
                            For Endorsement
                          </span>
                        </button>
                        <button onClick={this.handleOnHoldRequest}>
                          <span id="onHoldSelected" className="sortBtn">
                            OnHold
                          </span>
                        </button>
                        <button onClick={this.handleForReturnedRequest}>
                          <span id="forEndorsementSelected" className="sortBtn">
                            Returned
                          </span>
                        </button>
                        <button onClick={this.handleForRejectedRequest}>
                          <span id="rejectedSelected" className="sortBtn">
                            Rejected
                          </span>
                        </button>
                      </>
                    ) : (
                      <>
                        <button onClick={this.handleInProcessRequest}>
                          <span id="inProcessSelected" className="sortBtn">
                            In Process
                          </span>
                        </button>
                        <button onClick={this.handleCheckPreparationRequest}>
                          <span
                            id="checkPreparationSelected"
                            className="sortBtn"
                          >
                            Check Preparation
                          </span>
                        </button>
                        <button onClick={this.handleCheckPreparedRequest}>
                          <span id="checkPreparedSelected" className="sortBtn">
                            Check Prepared
                          </span>
                        </button>
                        <button onClick={this.handleCheckAvailableRequest}>
                          <span id="checkAvailableSelected" className="sortBtn">
                            Check Available
                          </span>
                        </button>
                        <button onClick={this.handleReleasedRequest}>
                          <span id="releasedSelected" className="sortBtn">
                            Released
                          </span>
                        </button>
                      </>
                    )}
                  </div>
                  {/* TABLE HEAD */}
                  {this.state.toggleReleased ? (
                    <div className="myRequestTableHeader">
                      <div className="tHead">CRF#</div>
                      <div className="tHead">Due date</div>
                      <div className="tHead">Vendor</div>
                      <div className="tHead">Check Amount</div>
                      <div className="tHeadExp" style={{ padding: "0px" }}>
                        Check Available Date
                      </div>
                      <div className="tHead">Date Released</div>
                      <div className="tHead">Department</div>
                      <div className="tHead">Project</div>
                      <div className="tHead">Requestor</div>
                      {/* <div className='tHead'>OR#</div> */}
                    </div>
                  ) : this.state.phase1 ? (
                    <div className="myRequestTableHeader">
                      <div className="tHead">CRF#</div>
                      <div className="tHead">Date Created</div>
                      <div className="tHeadExp" style={{ padding: "0px" }}>
                        Expected Completion Date
                      </div>
                      <div className="tHead">Due date</div>
                      <div className="tHead">Vendor</div>
                      <div className="tHead">Amount Requested</div>
                      <div className="tHead">Department</div>
                      <div className="tHead">Project</div>
                      <div className="tHead">Status</div>
                      <div className="tHead">Request Type</div>
                    </div>
                  ) : null}
                  {/*END TABLE HEAD */}
                </div>
              </div>
              {/* TABLE DATA */}

              <div
                className={
                  !this.state.toggleInProcess ||
                  !this.state.toggleCheckPreparation
                    ? "division"
                    : "division2"
                }
              ></div>

              {this.state.phase1 ? (
                <>
                  <AllRequestPagination
                    allRequests={this.sortList(allRequests)}
                    toggleReleased={this.state.toggleReleased}
                    formatDate={this.formatDate}
                    grandTotal={this.addCommas(this.state.grandTotal)}
                  />
                  <br />
                </>
              ) : (
                <>
                  {this.state.toggleAllRequests || this.state.toggleReleased ? (
                    <>
                      <Pagination
                        allRequests={this.sortList(allRequests)}
                        toggleReleased={this.state.toggleReleased}
                        formatDate={this.formatDate}
                        getOrNumber={this.getOrNumber}
                      />
                    </>
                  ) : null}
                </>
              )}

              {this.state.toggleInProcess ||
              this.state.toggleCheckPreparation ||
              this.state.toggleCheckPrepared ||
              (this.state.toggleCheckAvailable &&
                context.state.userRole === "Accounting Staff" || context.state.userRole === "Treasury" ) ? (
                <>
                  <div className="spreadSheet2">
                    <div className="spreadSheetContents">
                      <ReactDataSheet
                        data={this.state.grid}
                        valueRenderer={(cell) => cell.value}
                        onCellsChanged={(changes) => {
                          const grid = this.state.grid.map((row) => [...row]);
                          changes.forEach(({ cell, row, col, value }) => {
                            grid[row][col] = { ...grid[row][col], value };
                          });
                          this.setState({ grid });
                        }}
                      />
                    </div>
                  </div>
                  <br />
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "flex-start",
                      paddingRight: "3rem",
                      visibility:
                        parseFloat(this.state.grandTotal) === 0 ? "hidden" : "",
                    }}
                  >
                    <div style={{ flexBasis: "20%" }}>
                      <p style={{ textAlign: "right" }}>Total Amount:</p>
                    </div>
                    <div style={{ flexBasis: "30%" }}>
                      <p style={{ textAlign: "right" }}>
                        &#8369; {this.addCommas(this.state.grandTotal)}
                      </p>
                    </div>
                    <div style={{ flexBasis: "50%" }}>
                      <div
                        className="bottomTools"
                        style={{ marginTop: "-1rem" }}
                      >
                        {this.state.toggleInProcess ? (
                          <button
                            className="checkPreparationBtn"
                            onClick={this.handleShowModal}
                          >
                            Update
                          </button>
                        ) : null}

                        {this.state.toggleCheckPreparation ? (
                          <button
                            className="checkPreparationBtn"
                            onClick={this.handleShowModal}
                          >
                            Update
                          </button>
                        ) : null}

                        {this.state.toggleCheckPrepared ? (
                          <button
                            className="checkPreparationBtn"
                            onClick={this.handleShowModal}
                          >
                            Update
                          </button>
                        ) : null}

                        {this.state.toggleCheckAvailable ? (
                          <button
                            className="checkPreparationBtn"
                            onClick={this.handleShowModal}
                          >
                            Update
                          </button>
                        ) : null}
                      </div>
                    </div>
                  </div>
                </>
              ) : null}
            </div>
          </div>
        )}
      </CrfContext.Consumer>
    );
  }
}

const link = {
  textDecoration: "none",
  color: "black",
};

const colorRed = {
  color: "#ee3124",
};

const colorGray = {
  color: "#dcdbdb",
};

const amountRequested = {
  width: "100%",
  textAlign: "right",
  fontSize: "13px",
};

const displayNone = {
  display: "none",
};

export default MyDashboard;
